/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'

import { sitePath } from '../../../assets/ts/api/api'
import { openFile } from '../../../assets/ts/files/files'
import { defaultToEmptyString } from '../../../assets/ts/formatting/formatting'
import { handleScroll } from '../../../assets/ts/general/general'
import PageOverlayBusy from '../../../components/page-overlay/page-overlay-busy'
import usePiiAuditTrailMetadata from '../../../hooks/pii/use-pii-audit-trail-metadata'
import usePageAccumulator from '../../../hooks/usePageAccumulator'

const PiiAuditLog = () => {
  const [pageNum, setPageNum] = useState(0)
  const { piiAuditTrailMetadataIsLoading, refactoredPIIAuditData } = usePiiAuditTrailMetadata({
    isArchivedFilter: null,
    pageNumber: pageNum,
  })

  const accumulatedPIIAuditLog = usePageAccumulator(pageNum, refactoredPIIAuditData)

  const navigateToPath = (page: string, guid: string) => {
    return window.open(`${sitePath}/${page}/${guid}`)
  }

  /**determineLinkStatus
   * Navigates the to the link when appropriate otherwise is unclickable.
   * @param auditlog
   * @returns
   */
  const determineLinkStatus = ({ Audit }) => {
    if (!Audit.Comment.toLowerCase().includes('settings')) {
        return navigateToPath('detailview', Audit.ItemGUID)
    }
    return null
}


  const onTopScrollReached = (e) => {
    console.log(e)
  }
  const onBottomScrollReached = () => {
    if (100 > accumulatedPIIAuditLog.length) {
      setPageNum((num) => num + 1)
    }
  }
  /**getLabelsAndOccurrences
   * Processes a JSON string containing a `groupByParam` object to extract and format labels and their occurrences.
   *
   * The function parses the JSON string, checks if it contains the `groupByParam` object, and iterates over its
   * key-value pairs. For each item in `groupByParam`, it extracts the `label` and `occurrences`, formats them
   * as a string, and adds them to the result array. It handles cases where items might be undefined or null and
   * logs appropriate warnings or errors.
   *
   * @param {string} data - The JSON string to be parsed and processed.
   * @returns {Array<string>} An array of formatted strings, each representing a label and its occurrences.
   */
  function getLabelsAndOccurrences(data): string[] {
    const result: string[] = []

    try {
      const parsedData = JSON.parse(data)
      if (parsedData?.groupByParam) {
        const groupByParam = parsedData.groupByParam
        for (const [key, item] of Object.entries(groupByParam)) {
          if (item) {
            //Typo on the backend that needs fixing.
            const { label, occurrences } = item
            result.push(`${occurrences} ${label} `)
          } else {
            console.warn(`Item for key ${key} is undefined or null.`)
          }
        }
      } else {
        console.error('Invalid data structure:', parsedData)
      }
    } catch (error) {
      console.error('Error parsing data:', error)
    }
    return result
  }

  return (
    <>
      {piiAuditTrailMetadataIsLoading && <PageOverlayBusy />}
      <div className='container'>
        <div className='row'>
          <div className='col-sm-12 d-flex align-items-stretch'>
            <div className='shadow card w-100'>
              <div className='d-flex flex-column card-body h-100'>
                {accumulatedPIIAuditLog.map((metaData: any) => (
                  <div
                    className='auditlogs'
                    key={metaData.day}
                    onScroll={(e) => handleScroll(e, onTopScrollReached, onBottomScrollReached)}
                  >
                    <div className='bgcolor-40 py-2 px-2 border-radius'>
                      <h2
                        aria-label={metaData.day}
                        className='title-color9 poppins-semibold font-14 maxfitcontent py-2 m-0'
                        tabIndex={0}
                      >
                        {defaultToEmptyString(metaData.day)}
                      </h2>
                    </div>
                    <ul className='list-type-none progress v-steps w-100'>
                      {metaData.auditByDates.map((item) => {
                        const labelsAndOccurrences = getLabelsAndOccurrences(item.Audit.JsonResults)

                        return (
                          <li className='px-2 px-xl-3' key={item.AuditTime}>
                            <div className='progress-steps'>
                              <div className='audittime sourcesansprosemibold font-13 title-color37 '>
                                {defaultToEmptyString(item.AuditTime)}
                              </div>
                              <div className='circle'> </div>
                              <div
                                aria-live='polite'
                                className='progress-title pb-1 d-flex flex-column poppins-medium font-12'
                                tabIndex={0}
                              >
                                <span>
                                  <a className='links title-color38 ' href={item.aduittitlelink}>
                                    {defaultToEmptyString(item.Audit.FileName)}
                                  </a>{' '}
                                  <span>{defaultToEmptyString(item.Audit.EntityType)}</span>
                                </span>
                                <span className='font-10 title-color37 '>
                                  Inquiry ID:{' '}
                                  <a
                                    className='links'
                                    href={'#'}
                                    onClick={() => {
                                      determineLinkStatus(item)
                                    }}
                                  >
                                    {defaultToEmptyString(item.Audit.InquiryID)}
                                  </a>
                                </span>
                                {labelsAndOccurrences.length > 0 &&
                                  labelsAndOccurrences.map((item, key) => {
                                    return (
                                      <span className='font-10 title-color37 ' key={key}>
                                        {defaultToEmptyString(item)}
                                      </span>
                                    )
                                  })}
                                <span className='font-10 title-color37 '>
                                  {`By 
                                    ${defaultToEmptyString(item.Audit.ItemCreatedBy.properties.defaultDisplay)}
                                  `}
                                </span>
                              </div>
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default PiiAuditLog
